/**
 * Format a number as Mexican Pesos (MXN) with 2 decimals
 * e.g. $1,850,000.00
 */
export const formatMXN = (value) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(value || 0));

/**
 * Format a number as MXN compact (same format, 2 decimals)
 */
export const formatMXNCompact = (value) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(value || 0));

/**
 * Format a percentage
 */
export const formatPercent = (value) =>
  `${Number(value || 0).toFixed(1)}%`;

/**
 * Format month string "2025-01" to "Ene 2025"
 */
const MES_LABELS = {
  '01': 'Ene', '02': 'Feb', '03': 'Mar', '04': 'Abr',
  '05': 'May', '06': 'Jun', '07': 'Jul', '08': 'Ago',
  '09': 'Sep', '10': 'Oct', '11': 'Nov', '12': 'Dic',
};

export const formatMes = (mesStr) => {
  if (!mesStr) return '-';
  const [year, month] = mesStr.split('-');
  return `${MES_LABELS[month] || month} ${year}`;
};

/**
 * Format date string "2025-01-20" to "20-01-2025" (dd-mm-yyyy)
 */
export const formatDate = (dateStr) => {
  if (!dateStr) return '—';
  const parts = dateStr.split('-');
  if (parts.length === 3) return `${parts[2]}-${parts[1]}-${parts[0]}`;
  if (parts.length === 2) return `${MES_LABELS[parts[1]] || parts[1]} ${parts[0]}`;
  return dateStr;
};

/**
 * Format a number with thousands separator
 */
export const formatNumber = (value) =>
  new Intl.NumberFormat('en-US').format(Number(value || 0));
